<template>
   <el-dialog
        title=""
        :visible.sync="showComponent"
        center>
        <qrcode-vue
          :value="value"
          :size="size"
          level="H"></qrcode-vue>
        <div class="title">{{title}}</div>
    </el-dialog>
</template>
<style scoped>
    >>>.el-dialog{
        max-width: 360px;
        min-width: 225px;
    }
    .title{
        margin:0;
        padding:0;
        margin-top:15px;
        font-size: 18px;
        text-align: center;
    }
    >>>canvas{
        display: block;
        margin:  0 auto;
    }
</style>
<script>
  import QrcodeVue from 'qrcode.vue';
  export default {
    components:{QrcodeVue},
    name: "AlertComponent",
    data() {
      return {
          showComponent:false,
          value: "https://"+ window.location.host,
          size: 200,
          title:'打开微信扫一扫'
      };
    },
    mounted (){

    },
    created(){

    },
    methods: {
        closeDialog:function(type){
            this.showComponent = false;
        },
        show:function(obj){
            this.value = obj.url;
            this.title = obj.title || this.title;
            this.showComponent = true;
        },
        hide:function(){
            this.showComponent = false;
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AlertErweimaComponent.vue